import script from "./EditRoom.vue?vue&type=script&setup=true&lang=js"
export * from "./EditRoom.vue?vue&type=script&setup=true&lang=js"

import "./EditRoom.vue?vue&type=style&index=0&id=ec0bfb3a&lang=css"

const __exports__ = script;

export default __exports__